import translate from '@allesauto/i18n';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import './ArrowBox.css';

import ArrowBoxIcon, { CategoryNameType } from './CategoryNameIcon';

export enum ColorsType {
  purple = 'purple80',
  green = 'green60',
  grey = 'grey80',
}

export interface ArrowBoxProps {
  currentBoxIndex?: number;
  categoryName?: string;
  title: string;
  offersNumber: number;
  color?: ColorsType;
}

const ArrowBox: FC<ArrowBoxProps> = (props: ArrowBoxProps) => {
  const { currentBoxIndex, categoryName, title, offersNumber, color } = props;
  const intl = useIntl();

  const backgroundColor = currentBoxIndex
    ? currentBoxIndex % 3 === 1
      ? ColorsType.green
      : currentBoxIndex % 3 === 2
      ? ColorsType.purple
      : ColorsType.grey
    : color;

  const className = {
    box: `arrow_box_${backgroundColor}`,
    content: `sm:ml-[15px] sm:mt-[27px] md:ml-60px md:mt-60px text-${
      backgroundColor === ColorsType.purple ||
      backgroundColor === ColorsType.grey
        ? ColorsType.green
        : ColorsType.purple
    } monochrome:text-white`,
    title:
      'font-weight-bold text-headline3 sm:mt-[20px] md:mt-30px mr-40px hyphens-auto',
    description: 'text-p1 mt-10px',
  };

  return (
    <>
      <div className={className.box}>
        <div className={className.content}>
          {categoryName && (
            <div>
              <ArrowBoxIcon categoryName={categoryName as CategoryNameType} />
            </div>
          )}
          <h3 className={className.title}>{title}</h3>
          <p className={className.description}>
            {translate(intl, 'ui.SERVICE_BOOKING.SERVICE_OFFERS', {
              offersNumber,
            })}
          </p>
        </div>
      </div>
    </>
  );
};

export default ArrowBox;
